import React from 'react';
import SearchBar from '../common/SearchBar';
import Dropdown from '../common/Dropdown';
import Label from '../common/Label';
import DropdownSkeleton from '../common/DropdownSkeleton';

const FilterSection = ({
  search,
  handleSearchChange,
  allOrganizations,
  selectedOrganizationFilter,
  handleOrganizationFilterChange,
  selectedFacilityFilter,
  handleFacilityFilterChange,
  facilitiesForSelectedOrganization,
  isLoadingFilterFacilities,
  isLoadingOrganizations,
}) => {
  return (
    <div className="md:flex md:justify-between w-full bg-white p-5 my-4 shadow rounded-lg">
      {/* Filters */}
      <div className="flex-none mb-3 w-full md:w-[30%]">
        <SearchBar
          value={search}
          onChange={handleSearchChange}
          placeholder="Search by name or email"
          labelText="Search"
          inputClass="sm:max-w-full lg:max-w-full "
        />
      </div>

      {/* Organization Dropdown */}
      <div className="mb-3 md:w-[30%]">
        <Label variant="dark">Organization</Label>
        {isLoadingOrganizations ? (
          <DropdownSkeleton widthClass=" w-full" />
        ) : (
          <Dropdown
            options={allOrganizations.map((org) => ({ label: org.name, value: org.id }))}
            selectedOption={
              selectedOrganizationFilter
                ? selectedOrganizationFilter.label
                : 'Filter by Organization'
            }
            onSelect={handleOrganizationFilterChange}
            text="Select an Organization"
            disabled={false}
            onSearch={null}
            widthClass="w-full"
          />
        )}
      </div>

      {/* Facility Dropdown */}
      <div className="md:w-[30%]">
        <Label variant="dark">Facility</Label>
        {isLoadingFilterFacilities ? (
          <DropdownSkeleton widthClass="w-full md:w-full" />
        ) : (
          <Dropdown
            options={facilitiesForSelectedOrganization.map((facility) => ({
              label: facility.name,
              value: facility.id,
            }))}
            selectedOption={
              selectedFacilityFilter ? selectedFacilityFilter.label : 'Filter by Facility'
            }
            onSelect={handleFacilityFilterChange}
            text="Select a Facility"
            disabled={!selectedOrganizationFilter}
            onSearch={null}
            widthClass="w-full"
          />
        )}
      </div>
    </div>
  );
};

export default FilterSection;
